export const FU_DOMAIN = 'domain=folkeuniversitetet.no';
export const LINGU_DOMAIN = 'domain=lingu.com';
